// Photo filenames for Holiday Party 2018
const HOLIDAY_PARTY_2018 = [
  'xmass-2018-8_46306375672_z.jpg',
  'xmass-2018-9_31417954347_z.jpg',
  'xmass-2018-10_46306375492_c.jpg',
  'xmass-2018-11_32485269158_z.jpg',
  'xmass-2018-14_32485268998_z.jpg',
  'xmass-2018-16_32485268738_l.jpg',
  'xmass-2018-17_45444776935_z.jpg',
  'xmass-2018-18_32485268578_z.jpg',
  'xmass-2018-19_45444776445_z.jpg',
  'xmass-2018-22_31431577637_c.jpg',
  'xmass-2018-23_32498900858_c.jpg',
  'xmass-2018-24_32498900738_c.jpg',
  'xmass-2018-25_32498900648_l.jpg',
  'xmass-2018-26_32498900518_l.jpg',
  'xmass-2018-1_45444781625_z.jpg',
  'xmass-2018-2_46306376862_z.jpg',
  'xmass-2018-3_45444781035_z.jpg',
  'xmass-2018-4_46306376402_c.jpg',
  'xmass-2018-5_32485269868_z.jpg',
  'xmass-2018-6_46306375942_z.jpg',
  'xmass-2018-7_31417954807_z.jpg',
];

export default HOLIDAY_PARTY_2018;
